import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import SrBox from 'client/components/SrBox';

import './SrCardToggle.less';

const SrCardToggle = ({ title, label, children, titleComponent, noBorderTop, hidden }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  if (hidden) {
    return null;
  }

  return (
    <div
      styleName={classnames('SrCardToggle', {
        noBorderTop,
      })}
    >
      <div onClick={handleToggle} styleName="headerContainer">
        <div styleName="headerText">
          <div styleName="headerTitle">
            {titleComponent || (
              <SrText font="greycliff" weight="800">
                {title}
              </SrText>
            )}
          </div>
          {label && (
            <div styleName="headerLabel">
              {!isOpen && (
                <SrText font="greycliff" weight="800" color="grey" fontSize="16px">
                  {label}
                </SrText>
              )}
            </div>
          )}
        </div>
        <div styleName="iconContainer">
          <SrIcon className={classnames('arrow-rounded-grey', isOpen ? 'flipHorizontal' : null)} />
        </div>
      </div>
      {isOpen && <SrBox paddingTop="6px">{children}</SrBox>}
    </div>
  );
};

SrCardToggle.propTypes = {
  title: PropTypes.string,
  titleComponent: PropTypes.node,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default SrCardToggle;
